var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9154 10.8191H15.2282V13.0407H15.2893C15.8919 11.9632 17.3582 10.8191 19.5492 10.8191C24.1008 10.8191 24.9423 13.6517 24.9423 17.3368V25.1292H20.4462V18.2032C20.4462 16.6175 20.4129 14.5764 18.108 14.5764C15.803 14.5764 15.4087 16.301 15.4087 18.0894V25.1431H10.9154V10.8191ZM8.36331 6.48134C8.36331 6.9438 8.22617 7.39588 7.96924 7.78041C7.71231 8.16494 7.34712 8.46464 6.91986 8.64162C6.49259 8.81859 6.02244 8.8649 5.56886 8.77468C5.11528 8.68446 4.69865 8.46176 4.37163 8.13474C4.04462 7.80773 3.82192 7.39109 3.7317 6.93751C3.64148 6.48393 3.68778 6.01378 3.86476 5.58652C4.04174 5.15926 4.34144 4.79407 4.72597 4.53714C5.11049 4.2802 5.56257 4.14307 6.02504 4.14307C6.64496 4.1438 7.23928 4.39039 7.67763 4.82874C8.11598 5.26709 8.36257 5.86141 8.36331 6.48134ZM3.69232 10.8191H8.36331V25.1292H3.69232V10.8191Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInFooter);
export default __webpack_public_path__ + "static/media/LinkedIn_footer.775a9457676395a1b7a61284ed2c4a65.svg";
export { ForwardRef as ReactComponent };